export const ru = {
    common: {
        PIN_CODE_LABEL: 'Пин-код',
        USER_NAME_LABEL: 'Полное имя',
        comment: 'Комментарий',
        year: 'Год',
        configuration: 'Конфигурация',
        cancel: 'Отмена',
        search: 'Поиск',
        remove: 'Удалить',
        confirmationDialogTitle: 'Вы уверены, что хотите удалить этот элемент?',
        selectDate: 'Выберите дату',
        select: 'Выберите',
        notFound: 'Не найдено',
        equipmentPickerPlaceholder: 'Объект оборудования...',
        searchPlaceholder: 'Поиск...',
        equipmentTypePickerPlaceholder: 'Тип оборудования...',
        equipmentTypePickerTitle: 'Выберите тип оборудования',
        emptyTableMessage: 'Нет данных',
        flowPikcerTitle: 'Выберите поток',
        selectIcon: 'Выберите иконку',
        locationPickerTitle: 'Выберите местоположение',
        locationPlaceholder: 'Местоположение...',
        noSublocations: 'Нет подразделений',
        locationsTitle: 'Местоположения',
        edit: 'Редактировать',
        save: 'Сохранить',
        added: 'Добавлено',
        updated: 'Обновлено',
        add: 'Добавить',
        removed: 'Удалено',
        reload: 'Обновить',
        confirm: 'Подтвердить',
        rollBack: 'Отменить',
        images: 'Изображения',
        documents: 'Документы',
        download: 'Загрузить',
        saved: 'Сохранено',
        date: 'Дата',
        hour: 'Час',
        preview: 'Предпросмотр',
        data: 'Данные',
        attributes: 'Атрибуты',
        checkList: 'Список проверки',
        name: 'Имя',
        type: 'Тип',
        status: 'Статус',
        designation: 'Обозначение',
        symbol: 'Символ',
        serialNumber: 'Серийный номер',
        registryNumber: 'Регистрационный номер',
        machineNumber: 'Номер машины',
        udtNumber: 'Номер UDT',
        manufacturedYear: 'Год производства',
        manufacturer: 'Производитель',
        supplier: 'Поставщик',
        mainSupplier: 'Главный поставщик',
        attribute: 'Атрибут',
        nameRequired: 'Требуется имя',
        yearGreaterThan: 'Год должен быть больше',
        location: 'Расположение',
        fieldRequired: 'Это поле является обязательным',
        description: 'Описание',
        minimumQuantity: 'Минимальное количество',
        optimalQuantity: 'Оптимальное количество',
        priority: 'Приоритет',
        formatYYYY: 'Формат YYYY',
        storageQuantity: 'Количество на складе',
        quantity: 'Количество',
        quantityGreaterThan: 'Количество должно быть больше',
        machine: 'Машина',
        tool: 'Инструмент',
        order: 'Заказ',
        required: 'Обязательный',
        dateFormat: 'Формат даты',
        selectDictionary: 'Выбрать словарь',
        selectDictionaryValue: 'выбрать значение словаря',
        return: 'Вернуть',
        parameters: 'Параметры',
        editCategory: 'Редактировать категорию',
        addCategory: 'Добавить новую категорию',
        changeColor: 'Изменить цвет',
        noColor: 'Нет цвета',
        shift: 'Смена',
        start: 'Начало',
        end: 'Конец',
        shiftSchema: 'Схема смен',
        shifts: 'Смены',
        dictionary: 'Словарь',
        subEntries: 'Подзаписи',
        key: 'Ключ',
        value: 'Значение',
        moveUp: 'Переместить вверх',
        moveDown: 'Переместить вниз',
        addLocation: 'Добавить новое местоположение',
        editLocation: 'Редактировать местоположение',
        companiesDatabase: 'База данных компаний',
        flows: 'Потоки',
        read: 'Чтение',
        write: 'Запись',
        noImage: 'Нет изображения',
        email: 'Электронная почта',
        function: 'Функция',
        active: 'Активный',
        notActive: 'Не активирован',
        disabled: 'Отключен',
        entryNumber: 'Номер записи',
        issuedDate: 'Дата выдачи',
        expiresDate: 'Дата истечения',
        move: 'Переместить',
        separateForm: 'Разделить от',
        separate: 'Разделить',
        warehouse: 'Склад',
        actions: 'Действия',
        putInCurrentLocation: 'Поместить в текущее местоположение',
        selectLocationFormRightMenu: 'Выбрать местоположение из правого меню',
        showUnassignedItems: 'Показать неназначенные элементы',
        separated: 'Разделено',
        moved: 'Перемещено',
        categories: 'Категории',
        welcome: 'Добро пожаловать',
        loginToSignaloCMMS: 'Войдите в Signalo CMMS',
        login: 'Войти',
        loginByEmailAndPassword: 'Вход с помощью электронной почты и пароля',
        loginByCode: 'Вход по коду',
        accessCode: 'Код доступа',
        enterEmail: 'Введите электронную почту',
        enterPassword: 'Введите пароль',
        enterCode: 'Введите код',
        userNotFound: 'Пользователь не найден',
        userNotActivated: 'Пользователь не активирован',
        userDisabled: 'Пользователь отключен',
        wrongPassword: 'Неверный пароль',
        locations: 'Местоположения',
        pageNotFound: 'Страница не найдена',
        group: 'Группа',
        yes: 'Да',
        no: 'Нет',
        hourlyCost: 'Почасовая стоимость',
        price: 'Цена',
        newEntry: 'Новая запись',
        predictedFinishTime: 'Предполагаемое время завершения',
        ok: 'Ок',
        archive: 'Архив',
        costs: 'Расходы',
        companyManagement: 'Управление компанией',
        companyData: 'Данные компании',
        supportedLanguages: 'Поддерживаемые языки',
        en: 'Английский',
        pl: 'Польский',
        es: 'Испанский',
        de: 'Немецкий',
        it: 'итальянский',
        fr: 'французский',
        ru: 'русский',
        uk: 'украинский',
        pt: 'португальский',
        tr: 'турецкий',
        nl: 'нидерландский',
        sr: 'сербский',
        defaultLanguage: 'Язык по умолчанию',
        companyLogo: 'Логотип компании',
        notificationsManagement: 'Управление уведомлениями',
        category: 'Категория',
        today: 'Сегодня',
        month: 'Месяц',
        week: 'Неделя',
        day: 'День',
        close: 'Закрыть',
        show: 'Показать',
        rollBackFormalConfirmation: 'Формальное подтверждение отката',
        signUp: 'Зарегистрироваться',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Метка полного имени',
        userNameSurname: 'Полное имя',
        userSurnameName: 'Фамилия и имя',
        phone: 'Номер телефона',
        password: 'Пароль',
        password_confirmation: 'Подтвердите пароль',
        unassignedItems: 'Неназначенные элементы',
        currency: 'Валюта',
        general: 'Общий',
        timezone: 'Часовой пояс',
        users: 'Пользователи',
        groups: 'Группы',
        productionLine: 'Производственная линия',
        part: 'Часть',
        fittingParts: 'Соответствующие части',
        workSchema: 'Рабочая схема',
        workSchemas: 'Рабочие схемы',
        holiday: 'Праздник',
        changePassword: 'Изменить пароль',
        showRest: 'Показать остаток',
        pageNotPermitted: 'Страница не разрешена',
        waitingForActivation: 'Ожидание активации',
        editGroup: 'Редактировать группу',
        addGroup: 'Добавить группу',
        reportProblem: 'Сообщить о проблеме',
        describeOccuredIssue: 'Опишите возникшую проблему',
        markAllAsRead: 'Отметить все как прочитанные',
        unitType: 'Тип единицы',
        unit: 'Единица',
        unitPrice: 'Цена за единицу',
        notConfigured: 'Не настроено',
        rowsPerPage: 'Строк на странице',
        rowsOfPage: 'из',
        true: 'Истина',
        false: 'Ложь',
        export: 'Экспортировать',
        chooseFileFormat: 'Выберите формат файла',
        exported: 'Экспортировано',
        terminals: 'Терминалы',
        terminal: 'Терминал',
        selectEquipment: 'Выберите оборудование',
        futureIssues: 'Будущие проблемы',
        scheduledOn: 'Запланировано на',
        planned: 'Запланировано',
        notPlanned: 'Не запланировано',
        showOpenIssues: 'Показать открытые проблемы',
        pin: 'PIN',
        assignedEquipment: 'Назначенное оборудование',
        terminalEquipment: 'Оборудование терминала',
        detach: 'Отсоединить',
        attach: 'Присоединить',
        dashboardConfig: 'Конфигурация панели управления',
        addColumn: 'Добавить столбец',
        addRow: 'Добавить строку',
        removeRow: 'Удалить строку',
        registerTerminal: 'Зарегистрировать терминал',
        issueGeneratesCost: 'Время простоя генерирует затраты',
        selectColor: 'Выберите цвет',
        belowMinimum: 'Ниже минимума',
        belowOptimum: 'Ниже оптимума',
        synchronization: 'Синхронизация',
        synchronizationExport: 'Экспорт запасных частей',
        synchronizationImport: 'Импорт запасных частей',
        mapping: 'Отображение',
        returnTo: 'Вернуться',
        jobStatusses: 'Процессы',
        hidden: 'Скрытый',
        editEvent: 'Редактировать событие',
        threeDays: '3 дня',
        addEvent: 'Добавить событие',
        plannedIssues: 'Запланированные проблемы',
        currentService: 'Текущая обслуживаемость',
        searchLocation: 'Найти местоположение',
        all: 'Все',
        unfinished: 'Незавершенный',
        numberOfIssues: 'Количество проблем',
        unknown: 'Неизвестный',
        partEntry: 'Часть (вход)',
        foundItems: 'Найденные элементы',
        output: 'Выход',
        copied: 'Скопировано',
        link: 'Ссылка',
        authorizationRequired: 'Требуется авторизация',
        authorizationRequiredDescriptionUser:
            'К сожалению, у вас недостаточно полномочий {value}. Попросите авторизованного лица утвердить действие.',
        authorizationRequiredDescriptionTerminal:
            'Используйте свой код доступа, чтобы авторизовать действие.',
        showAll: 'Показать все',
        showClassicView: 'Показать классический вид',
        noIssuesInCategory: 'В этой категории нет проблем.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Количество проблем в этой категории и подкатегориях.',
        numberOfIssuesInThisCategory: 'Количество проблем в этой категории.',
        minBarcodeLength: 'Минимальная длина штрих-кода',
        currentPage: 'Текущая страница',
        allPages: 'Все страницы',
        selectFormat: 'Выберите формат',
        provided_currency: 'Предоставленная валюта',
        provided_quantity: 'Предоставленное количество',
        provided_unit: 'Предоставленный единица',
        provided_unit_price: 'Предоставленная цена за единицу',
        unit_price: 'Цена за единицу',
        quantity_available: 'Доступное количество',
        editBarcode: 'Изменить штрих-код',
        crews: 'Команды',
        scheduleEventTypes: 'Типы графика событий',
        crew: 'Команда',
        scheduleEvent: 'Событие в графике',
        available: 'Доступный',
        'App\\Models\\Crew': 'Команда',
        'App\\Models\\User': 'Пользователь',
        'App\\Models\\Equipment': 'Оборудование',
        'App\\Models\\Part': 'Часть',
        Crew: 'Команда',
        User: 'Пользователь',
        Equipment: 'Оборудование',
        Part: 'Часть',
        scheduleEvents: 'События в графике',
        event: 'Событие',
        externalSystems: 'Внешние системы',
        user: 'Пользователь',
        availability: 'Доступность',
        inheritColorFromParentIfCustomNotSet:
            'Наследовать цвет от родителя, если не установлен свой',
        pickFromAllParts: 'Выбрать из всех частей',
        takeTool: 'Взять инструмент',
        returnTool: 'Вернуть инструмент',
        personWhoTake: 'Человек, взявший',
        personWhoReturn: 'Человек, вернувший',
        takenAt: 'Взято в',
        takenBy: 'Взято',
        toolIssuedBy: 'Инструмент выдан',
        commentTake: 'Комментарий при взятии',
        commentReturn: 'Комментарий при возврате',
        change: 'Изменить',
        onlyWithActiveRMIssues: 'Только с активными запросами RM',
        externalSystem: 'Внешняя система',
        rejectIssue: 'Отклонить проблему',
        withdrawIssueRejection: 'Отменить отклонение проблемы',
        rejectionReason: 'Причина отклонения',
        rejected: 'Отклонено',
        showCrewMembers: 'Показать участников команды',
        crewMembers: 'Участники команды',
        helpGroup: 'Служба',
        partsTakenByUser: 'Части, взятые пользователем',
        pickParts: 'Выдать части',
        selectPersonWhoTakes: 'Выбрать человека, взявшего',
        changePersonWhoTakes: 'Изменить человека, взявшего',
        quantityToPick: 'Количество для выдачи',
        pickLocation: 'Место выдачи',
        selectPartsToPick: 'Выберите детали для выдачи',
        partSelected: 'Выбранная деталь',
        scanCodeOr: 'Сканируйте код или',
        returnPart: 'Вернуть деталь',
        myTakenParts: 'Детали, выданные мне',
        takenFromLocation: 'Взято из места',
        takenQuantity: 'Количество, взятое',
        providedUnit: 'Единица измерения',
        providedQuantity: 'Предоставленное количество',
        selectFromStorage: 'Выбрать из склада',
        selectFromMyPickedParts: 'Выбрать из моих выданных деталей',
        exportProcessInProgressMessage:
            'Процесс экспорта данных только начался, по завершении вы получите соответствующее уведомление со ссылкой на файл.',
        yourDocumentIsReady: 'Ваш документ готов',
        rotateScreen: 'Повернуть экран',
        addRule: 'Добавить правило',
        editRule: 'Изменить правило',
        summary: 'Итог',
        onlyAvailableEmployees: 'Показать только доступных сотрудников',
        calculated_unit_price: 'Конвертированная цена единицы продукции',
        calculated_quantity: 'Пересчитанное количество',
        next: 'следующий',
        maintenanceMode: 'Режим технического обслуживания',
        applicationMayBeUnavailableForFewMinutes:
            'Приложение может быть недоступно в течение нескольких минут',
        appWillRefreshIn: 'Приложение перезагрузится в',
        landscape: 'альбомная',
        portrait: 'портретная',
        orientation: 'ориентация',
        format: 'формат',
        service: 'слуги',
        leader: 'бригадиры',
        defaultView: 'вид по умолчанию',
        view: 'вид',
        oneDay: 'один день',
        object: 'объект',
        finished: 'готово',
        onlyNotFinished: 'Только не закончено',
        generate: 'генерировать',
        error: 'ошибка',
        cell: 'ячейка',
        resolutionSummary: 'Конец резюме',
        rejected_at: 'дата отказа',
        rejected_by: 'Отклонено',
        finishedByUser: 'Завершено',
        formalConfirmByUser: 'Официальное подтверждение',
        formalConfirmAt: 'Дата официального подтверждения',
        valueDeleted: '[Значение удалено]',
        hasNotPlannedIssue: 'Не имеет запланированных проблем',
        showInStorage: 'Показать в хранилище',
        changeCode: 'Изменить код',
        staffProfiles: 'Профили сотрудников',
        profile: 'Профиль',
        user_bug: 'Ошибка приложения',
        user_kaizen: 'Предложение об изменении',
        changeSuggestions: 'Изменить предложения',
        showOnlyCurrentlyAvailable:
            'показывать только доступные в данный момент',
        resetPassword: 'Напомнить пароль',
        forgotPassword: 'Забыли пароль',
        resetPasswordMailSent:
            'Мы отправили ссылку для установки нового пароля на указанный адрес электронной почты',
        manyEventsThisTime: 'Многие события в это время',
        importScheduleCheckboxLabel:
            'Удалить запланированные события в выбранном месяце для сотрудников, перечисленных в файле',
        inheritedEvent: 'Унаследованное событие',
        inheritedModifiedEvent: 'Модифицированное унаследованное событие',
        equipmentId: 'Идентификатор оборудования',
        entryId: 'Идентификатор записи',
        partId: 'Идентификатор детали',
        suggestionsEmail:
            'Электронная почта, на которую будут отправлены предложения по изменению',
        meters: 'счетчики',
        scanCardToAuth:
            'Прикоснитесь картой к считывателю или введите свой код доступа, чтобы подтвердить свою личность.',
        scanCard: 'Отсканируйте карту',
        cart: 'Ящик для обмена',
        emptyCardMessage:
            'Начните сканировать товары или выберите их из списка, чтобы добавить в корзину.',
        terminalMode: 'тип терминала',
        askPermittedUserToConfirmPartsExchange:
            'Попросите уполномоченное лицо подтвердить выпуск детали, отсканировав карту или введя код.',
        partsIssued: 'Выпущено частей',
        areYouSureAboutCancel: 'Вы уверены, что хотите отменить этот заказ?',
        areYouSureAboutRemoveFromCart:
            'Вы уверены, что хотите удалить этот товар из корзины?',
        standard: 'стандарт',
        idNumber: 'Идентификационный номер',
        takeParts: 'Взять детали',
        returnParts: 'Вернуть детали',
        quantityToReturn: 'Количество для возврата',
        partsPendingApproval: 'Детали, ожидающие утверждения',
        partsReturned: 'Возвращенные детали',
        partsAddedToPendingApproval: 'Детали добавлены в ожидающие утверждения',
        approvePartsReturn: 'Утвердить возврат деталей',
        partReturnApproved: 'Возврат деталей утвержден',
        partUsage: 'Использование деталей',
        awaitsReturn: 'Ожидает возврата',
        entrySelection: 'Выбор записи',
        correctQuantity: 'Исправить количество',
        quantityCorrection: 'Корректировка количества',
        entrySelectionAsc: 'Выбор записи (по возрастанию)',
        entrySelectionDesc: 'Выбор записи (по убыванию)',
        metersSettings: 'Настройки счетчиков',
        countableFields: 'Подсчитываемые поля',
        equipmentTypes: 'Типы оборудования',
        fieldName: 'Название поля',
        countableField: 'Подсчитываемое поле',
        partsStatusTaken: 'Взятые детали',
        rejectPartsReturn: 'Отклонить возврат деталей',
        areYouSureAboutRejectPartsReturn:
            'Вы уверены, что хотите отклонить возврат деталей?',
        partReturnRejected: 'Возврат деталей отклонен',
        counterFields: 'Поля счетчиков',
        counterName: 'Название счетчика',
        counterFieldName: 'Название поля счетчика',
        counterId: 'Идентификатор счетчика',
        counterUUID: 'UUID счетчика',
        counterPickerPlaceholder: 'Выберите счетчик',
        pickFromPartsList: 'Выбрать из списка деталей',
        changeLocation: 'Изменить местоположение',
        isPartStorageRoot: 'корневым хранилищем деталей',
        isStorageRoot: 'корневым хранилищем деталей',
        areYouSureAboutArchiveIssue:
            'Вы уверены, что хотите архивировать эту проблему?',
        ganttChart: 'Диаграмма Ганта',
        table: 'Таблица',
        fittingEquipment: 'Оборудование для установки',
        notAssigned: 'Не назначено',
        counters: 'Счетчики',
        machineHourlyCostNotProvided: 'Почасовая стоимость машины не указана',
        eventTypesMightBeDefinedHere: 'Здесь можно определить типы событий',
        toolsTakenByUser: 'Инструменты, взятые пользователем',
        predictedReturnDate: 'Предполагаемая дата возврата',
        estimatedTimeOfUsingToolInHours:
            'Предполагаемое время использования инструмента в часах',
        showOnlyAvailable: 'Показать только доступные',
        toolTakeLog: 'Журнал взятия инструмента',
        takeDate: 'Дата взятия',
        returnDate: 'Дата возврата',
        personWhoAcceptReturn: 'Человек, принявший возврат',
        statisticStrategy: 'Стратегия доступности',
        EquipmentPlannedStrategy: 'По плану работы',
        EquipmentConstantAvailabilityStrategy: 'Всегда доступен',
        actionAfterIssueFinish: 'Действие после завершения выпуска',
        enabled: 'Включено',
        categoryOfNewIssue: 'Категория новой проблемы',
        workNotStarted: 'Работа не начата',
        colorInherited: 'Цвет унаследован',
        abcClassification: 'Классификация ABC',
        xyzClassification: 'Классификация XYZ',
        classification: 'Классификация',
        filters: 'Фильтры',
        wipeFilters: 'Сбросить фильтры',
        takePartsFromUser: 'Взять детали у пользователя',
        selectPersonWhoReturns: 'Выберите человека, который вернет детали',
        changePersonWhoReturns: 'Изменить человека, который вернет детали',
        returnLocation: 'Местоположение возврата',
        returnQuantity: 'Количество возврата',
        globalSettings: 'Глобальные настройки',
        delimiter: 'Разделитель',
        fieldRules: 'Правила поля',
        fieldValue: 'Значение поля',
        user_email_regex:
            'Регулярное выражение для электронной почты пользователя',
        barcodeLength: 'Длина штрих-кода',
        partLine: 'Линия деталей',
        partFamily: 'Семейство деталей',
        partBatch: 'Партия деталей (batch)',
        testValueValid: 'Тестовое значение действительно',
        testValueNotValid: 'Тестовое значение недействительно',
        canBePicked: 'Может быть выбран',
        issue_criticality: 'Проблемы - критичность',
        issue_help_webapp: 'Проблемы - требуется поддержка (приложение)',
        issue_help_terminal: 'Проблемы - требуется поддержка (терминал)',
        issue_kind: 'Тип отчета',
        HIDE: 'скрывать',
        SHOW: 'Показывать',
        REQUIRE: 'требовать',
        propagateValues: 'Распространение значения',
        archived: 'в архиве',
        singleEvent: 'Однократная',
        seriesOfEvents: 'Серия записей',
        omitWeekends: 'Избегайте выходных',
        allEntriesSaved: 'Все записи добавлены',
        parentCategory: 'Родительская категория',
        first_day_of_week: 'Первый день недели',
        assignEmployee: 'Назначить сотрудника',
        addNewMachine: 'Добавить новую машину',
        addNewTool: 'Добавить новый инструмент',
        parentLocation: 'Родительское местоположение',
        equipmentStates: 'Cостояния оборудования',
        equipmentState: 'Состояние оборудованиo',
        fontColor: 'Цвет шрифта',
        downtime: 'Время простоя',
        setState: 'Установить состояние',
        from: 'от',
        to: 'к',
        inProgress: 'в ходе выполнения',
        noEntries: 'нет записей',
        products: 'продукты',
        product: 'продукт',
        setCurrentProduct:
            'Установите продукт, который в настоящее время находится в производстве',
        commentable: 'Возможность комментировать',
        allows_state_update:
            'Требуется изменение состояния во время комментария',
        undescribed: 'неописуемый',
        state: 'Состояние',
        productionMonitor: 'Производственный монитор',
        undescribedStates: 'Неописанные состояния',
        toolsPicker: 'Взять / вернуть инструменты',
        toolsGroups: 'Группы инструментов',
        of: 'из',
        image: 'Фото',
        selectTools: 'Выберите инструменты',
        takeTools: 'Скачать инструменты',
        returnTools: 'Верните инструменты',
        askPermittedUserToConfirmToolsExchange:
            'Попросите уполномоченное лицо подтвердить выдачу/возврат инструментов путем сканирования карты или ввода кода.',
        toolsPendingApproval: 'Возвращенные инструменты ожидают одобрения',
        production_monitor_visible_columns:
            'Монитор производства – видимые столбцы',
        details: 'Подробности',
        otherData: 'Другие данные',
        showAllTools: 'Показать все инструменты',
        allTools: 'Все инструменты',
        approveToolReturn: 'Согласитесь на возврат инструмента',
        rejectToolReturn: 'Отклонить возврат инструмента',
        areYouSureAboutRejectToolReturn:
            'Вы уверены, что хотите отклонить возврат инструмента?',
        areYouSureAboutAcceptToolReturn:
            'Вы уверены, что хотите подтвердить возврат инструмента?',
        toolReturnApproved: 'Возврат инструмента одобрен',
        toolReturnRejected: 'Возврат инструмента отклонен',
        toReturn: 'Вернуться',
        toolsCart: 'Обменный ящик - инструменты',
        toolsIssued: 'Инструменты загружены',
        toolsAddedToPendingApproval:
            'Инструменты добавлены в список ожидания одобрения возврата.',
        toolsReturned: 'Инструменты возвращены',
        mainShift: 'Основная смена',
        scanCode: 'Сканируйте код',
        codeRecognized: 'Код распознан',
        moveAllEntriesFromCurrentLocation:
            'Переместить все записи из этого места',
        newAwaitingValue: 'Новое значение ожидает утверждения',
        newValuesArePendingConfirmation: 'Изменения ждут одобрения',
        changeRequests: 'Запросы на изменение',
        currentValues: 'Текущие значения',
        requestedValues: 'Ценности, которые нужно изменить',
        removeRequestIsWaitingForApprove: 'Удаление ожидает одобрения',
        imageRemoveRequestLabel: 'Удаление фотографии',
        areYouSureAboutCancelChangeRequest:
            'Вы уверены, что хотите отменить запрос на изменение?',
        document: 'документ',
        rename: 'Переименовать',
        openInEditor: 'Открыть в редакторе',
        unsavedChangesMayBeLost: 'Несохраненные изменения могут быть потеряны.',
        location_name_regex: 'Правило названия местоположения',
        employeesWorkingCount:
            'Количество сотрудников, работающих над этим вопросом',
        always: 'всегда',
        indexes: 'Индексы',
        indexesEntriesTypes: 'Типы записей',
        indexEntry: 'Индексная запись',
        index: 'Индекс',
        pickIndex: 'Выберите индекс',
        report: 'Отчет',
        reportGenerationInProgress: 'Отчет генерируется',
        production_monitor_equipment_state_change:
            'Изменение состояния машины с производственного монитора',
        part_entries_auto_barcode_generation:
            'Автоматическое формирование штрих-кодов для записей деталей',
        new_issue_equipment_kind: 'Тип оборудования в новом уведомлении',
        manageVisibleColumns: 'Настройка видимости столбца',
        columnName: 'Имя столбца',
        visible: 'Видимый',
        partStorageRootWarningMessage:
            'Это местоположение будет установлено в качестве местоположения склада основных деталей, склад и окно выбора местоположения склада позволят вам выбирать только записи, расположенные в этом месте.',
        entriesLocation: 'расположение записей',
        cloneIssue: 'Клонировать',
        machinesMap: 'Карта машины',
        doYouWantToAddNewMarker: 'Хотите добавить сюда новый тег?',
        areYouSureAboutRemoveMarker: 'Вы уверены, что хотите удалить этот тег?',
        plants: 'Фабричные заводы',
        plant: 'Фабрика',
        buildings: 'Здания',
        building: 'Здание',
        floors: 'Этажи',
        floor: 'Пол',
        map: 'карта',
        areYouSureAboutMoveMarker:
            'Вы уверены, что хотите переместить этот маркер?',
        marker: 'Маркер',
        addNewMarkerTooltipMessage:
            'Чтобы добавить новый маркер, щелкните правой кнопкой мыши на карте.',
        takenTools: 'Выпущенные инструменты',
        askPermittedUserToConfirmToolExchange:
            'Попросите уполномоченное лицо подтвердить выдачу/возврат инструмента путем сканирования карты или ввода кода.',
        warnDays: 'Оповещение до истечения срока действия (дней)',
        licenseType: 'Тип лицензии',
        licenseGroup: 'Группа лицензий',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Требовать подтверждения / отклонения при возврате загруженных инструментов',
        attachments: 'Вложения',
        attachment: 'Вложение',
        searchInCurrentLocation: 'Искать в вашем текущем местоположении',
        icon: 'Икона',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'другой',
        tags: 'карты',
        tag: 'карта',
        userPinCode: 'PIN-код пользователя карты',
        pin_code_field_type: 'Тип пин-кода',
        alphanumeric: 'Буквенно-цифровой',
        numeric: 'Числовой',
        showCodeOwnerNameDuringParing:
            'Показывать имя владельца кода при сопряжении с картой/тегом',
        showUsernameInCart: 'Показывать имя пользователя в корзине',
        flag: 'Флаг',
        flags: 'Флаги',
        manageFlags: 'Управление флагами',
        skills: 'Навыки',
        skill: 'Навык',
        skillRank: 'Рейтинг',
        selectToolsByType: 'Выбирайте инструменты по типу',
        openToolsPickerOnCartInit:
            'Автоматически открывать окно выбора инструмента при переходе в корзину.',
        toolsTypes: 'Типы инструментов',
        workOrderTemplates: 'Шаблоны заказов на работу',
        workOrderTemplate: 'Образец заказа на работу',
        workOrders: 'Заказы на работу',
        workOrder: 'Порядок работы',
        employee: 'Сотрудник',
        workOrderCreatedBy: 'По заказу',
        print: 'Распечатать',
        issueCreated: 'Билет создан.',
        newIssue: 'Новый отчет',
        sampleButtonPlaceholder: 'Образец кнопки',
        preferences: 'Предпочтения',
        buttonsSize: 'Размер кнопки',
        defaultValue: 'Значение по умолчанию',
        warning: 'предупреждение',
        allowedIssuesCategories: 'Разрешенные категории проблем',
        hideAbilityToAssignEmployeesToIssue:
            'Скрыть возможность назначать сотрудников на решение задачи',
        issuesWithRelatedCategories: 'Включить подкатегории',
        issuesLimit: 'Лимит вопросов',
        issuesLimits: 'Проблемы – ограничения',
        closeLocker: 'Закройте шкаф',
        closeLockerMessage: 'Чтобы продолжить, закройте кабинет',
        closedTooFast: 'Вы закрылись слишком быстро?',
        doYouWantToReopenLocker: 'Хотите снова открыть шкафчик?',
        reopen: 'Открыть заново',
        quit: 'Заканчивать',
        hiddenFields: 'Скрытые поля',
        defaultValues: 'Значения по умолчанию',
        paddingBottom: 'Пустое место внизу',
        allVisibleFieldsRequired: 'Требовать заполнения всех видимых полей',
        emailConfirmation: 'Подтверждение адреса электронной почты',
        user_active_after_email_confirm:
            'Учетная запись пользователя автоматически активируется после подтверждения вашего адреса электронной почты.',
        phone_change_requires_confirmation_code:
            'Изменение номера телефона требует подтверждения кодом',
        toolsLocation: 'Расположение инструмента',
        manageFilters: 'Управление фильтрами',
        erase: 'стереть',
        can_pick_undescribed_equipment_state:
            'Возможность выбрать неописуемое состояние',
        helpdesk: 'служба поддержки',
        measureTypes: 'Виды измерений',
        measureType: 'Тип измерения',
        measurable: 'Измеримый показатель',
        measurables: 'Измеримые показатели',
        measurements: 'Измерение',
        measurement: 'Измерение',
        measuredAt: 'Дата измерения',
        employeeNumber: 'Количество работников',
        lastLocation: 'Последнее местоположение',
        readonly: 'Только чтение',
        equipment: 'Оборудование',
        conditions: 'Условия',
        permission: 'Разрешение',
        formula: 'формула',
        notification: 'Уведомление',
        transition: 'Переход',
        fillValuesToChangeState: 'Заполните значения, чтобы изменить статус.',
        loginTo: 'Авторизоваться',
        appName: 'Signalo CMMS',
        manageState: 'Управление состоянием',
        webMessage: 'Веб-сообщение',
        terminalId: 'Идентификатор терминала',
        operatorId: 'Идентификатор оператора',
        newConversation: 'Новый поток',
        application: 'Приложение',
        phones: 'Телефонные номера',
        message: 'Wiadomość',
        channels: 'каналы',
        url: 'URL-адрес',
        kind: 'Добрый',
        forkfleetConfigId: 'Конфигурация Forkfleet',
        create: 'создавать',
        terminate: 'прекратить',
        recreateIssue: 'Восстановить билет',
        ordinal: 'Порядковый номер',
        parameterName: 'Имя параметра',
        backgroundColor: 'Фоновый цвет',
        columns: 'Число столбцов',
        colspan: 'Ширина (столбцы)',
        fill: 'Полный',
        duplicate: 'Дублировать',
        loginAsThisUser: 'Войдите как этот пользователь',
        partLot: 'Ряд',
        minBrowserVersion: 'Требуется минимальная версия браузера',
        currentVersion: 'Текущая версия',
        equipment_planned_completed_percent_target:
            'Целевой процент выполнения плановых проверок',
        autoTranslate: 'Автоматический перевод',
        auto_translation: 'Автоматический перевод',
        awaitingAutoTranslation: 'Ожидание автоматического перевода',
        signaturePinTagConfirmationText1:
            'Подписаться с помощью @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'или отсканируйте свою карту.',
        signedWithPinCode: 'Подписано @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Подписано картой/биркой',
        trusted_device_code_login_users_limit:
            'Быстрый вход - количество отображаемых пользователей',
        display_fields_issue_created_at: 'Показывать поля - Создание отчета',
        docs_sidebar_hidden_by_default:
            'Документы - скрыть боковую панель по умолчанию',
        issue: 'Сообщение',
        control: 'Контроль',
        compatibility: 'Совместимость',
        replacement: 'Замена',
        backCompatibility: 'Двунаправленная совместимость',
    },
    placeholders: {
        part: 'Выберите деталь...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Номер телефона...',
        password: 'Пароль...',
        password_confirmation: 'Подтвердите пароль...',
        email: 'Электронный адрес...',
    },
    auth: {
        notYourAccountQuestion: 'Не ваш аккаунт?',
    },
    signup: {
        registered: 'Успешно!',
        emailConfirmed: 'Электронная почта была подтверждена.',
        registered_info:
            'Попросите своего руководителя активировать ваш аккаунт',
        confirmEmailAddress:
            'Ваша учетная запись создана. Нажмите ссылку в электронном письме, чтобы подтвердить свой адрес.',
        tokenNotFoundError:
            'Адрес электронной почты уже подтвержден или ссылка для подтверждения недействительна.',
    },
    paramTypes: {
        text: 'Текст',
        note: 'Заметка',
        integer: 'Целое число',
        decimal: 'Десятичное число',
        date: 'Дата',
        time: 'Время',
        datetime: 'Дата и время',
        color: 'Цвет',
        icon: 'Иконка',
        boolean: 'Нет / Да',
        signature: 'подпись',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Имя',
        path: 'Путь к файлу',
        category: 'Категория',
        equipment: 'Оборудование',
        criticality: 'Критичность',
        status: 'Статус',
        created: 'Создано',
        createdBy: 'Создано',
        fp: 'FP',
        type: 'Тип',
        designation: 'Обозначение',
        symbol: 'Символ',
        serialNumber: 'Серийный номер',
        registryNumber: 'Регистрационный номер',
        udtNumber: 'UDT номер',
        manufacturedYear: 'Год производства',
        actions: 'Действия',
        title: 'Название',
        data: 'Дата',
        archived: 'В архиве',
        manufacturerSymbol: 'Символ производителя',
        min: 'Мин',
        opt: 'Опт',
        quantity: 'Количество',
        priority: 'Приоритет',
        price: 'Цена',
        kind: 'Вид',
        description: 'Описание',
        default: 'По умолчанию',
        warning: 'Предупреждение',
        problem: 'Проблема',
        fixing: 'Исправление',
        changeOrder: 'Изменить заказ',
        required: 'Обязательно',
        icon: 'Иконка',
        color: 'Цвет',
        subCategories: 'Подкатегории',
        barCode: 'Штрих-код',
        subLocations: 'Подлокации',
        categories: 'Категории',
        image: 'Изображение',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'Электронная почта',
        phone: 'Номер телефона',
        function: 'Функция',
        department: 'Отдел',
        accountStatus: 'Статус аккаунта',
        shift: 'Смена',
        licenseNumber: 'Номер лицензии',
        issuedDate: 'Дата выдачи',
        expiresDate: 'Дата истечения',
        entries: 'Записи',
        entryNumber: 'Номер записи',
        buyPrice: 'Цена покупки',
        currentLocationQuantity: 'Количество в текущем местоположении',
        group: 'Группа',
        string: 'Текст',
        integer: 'Целое число',
        toolsGroup: 'Группа инструментов',
        manufacturer: 'Производитель',
        shortName: 'Короткое название',
        locationName: 'Название местоположения',
        subLocationsQuantity: 'Количество подлокаций',
        isWorkingOnIssue: 'Работает над проблемой',
        openIssues: 'Открытые проблемы',
        notificationDate: 'Дата уведомления',
        titleAndDescription: 'Заголовок и описание',
        read: 'Прочитано',
        created_at: 'Создано',
        received_at: 'Получено',
        started_at: 'Принято',
        arrived_at: 'Прибыло',
        finished_at: 'Закончено',
        country: 'Страна',
        city: 'Город',
        progress: 'Прогресс',
    },
    searchConfig: {
        id: 'ID',
        name: 'Имя...',
        shortName: 'Короткое имя...',
        country: 'Страна...',
        email: 'Электронная почта...',
        group: 'Группа...',
        planned: 'Запланировано',
        category: 'Категория...',
        object: 'Объект...',
        criticality: 'Критичность',
        fp: 'FP',
        type: 'Тип...',
        designation: 'Обозначение...',
        symbol: 'Символ...',
        serialNumber: 'Серийный номер...',
        registryNumber: 'Регистрационный номер...',
        udtNumber: 'Номер UDT...',
        manufacturedYear: 'Год производства...',
        manufacturerSymbol: 'Символ производителя...',
        priority: 'Приоритет...',
        quantity: 'Количество...',
        buyPrice: 'Цена покупки...',
        kind: 'Тип...',
        toolsGroup: 'Группа инструментов...',
        function: 'Функция...',
        department: 'Отдел...',
        status: 'Статус...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Телефон...',
        barCode: 'Штрих-код',
        color: 'Цвет...',
        icon: 'Иконка...',
        machine: 'Машина...',
        tool: 'Инструмент...',
        urgentAndOutdated: 'Срочный и устаревший',
        urgent: 'Срочный',
        expired: 'Истекший',
        manufacturer: 'Производитель',
    },
    errors: {
        error: 'Произошла ошибка',
        wrongEmail: 'Недопустимый адрес электронной почты',
        wrongPasswordLength: 'Длина пароля должна быть не менее 8 символов.',
        wrongCodeLength: 'Длина кода должна быть не менее 5 символов.',
        passwordsNotMatch: 'Пароли не совпадают',
        codesNotMatch: 'Коды не совпадают',
        codeAlreadyInUse: 'Код уже используется',
        expiresDateLowerThanIssued:
            'Дата истечения не может быть меньше, чем дата выдачи.',
        cannotMoveToTheSameLocation:
            'Нельзя переместить в то же местоположение.',
        locationRequired: 'Требуется местоположение.',
        putQuantity: 'Укажите количество для разделения.',
        valueGreaterThanQuantity: 'Значение больше, чем общее количество.',
        wholeCannotBeDistinguished: 'Целое не может быть разделено.',
        yearMustBeGreaterThan: 'Год должен быть больше ',
        passwordConfirmationNotMatch: 'Пароли не совпадают',
        mustBeInteger: 'Значение должно быть целым числом',
        valueTooLong: 'Значение слишком длинное',
        wrongPhoneNumber: 'Неверный номер телефона',
        phoneNumberAlreadyTaken: 'Номер телефона уже занят',
        emailAlreadyTaken: 'Email уже занят',
        notFound: 'Не найдено',
        sessionExpired: 'Сессия истекла',
        tenantNotFound:
            'Указанная конфигурация не существует. Проверьте адрес сайта и повторите попытку.',
        selectEquipmentTypeToConfigureParameters:
            'Выберите тип оборудования для настройки параметров.',
        noParametersToConfigure:
            'Выбранный тип оборудования не имеет параметров для настройки.',
        terminalAlreadyRegistered: 'Терминал уже зарегистрирован.',
        invalidPin: 'Недействительный PIN',
        eventCollision:
            'Время события, которое вы хотите добавить, пересекается с временем другого события.',
        mustStartWithSlash: 'Должен начинаться с /',
        mustBeBetween: 'Значение должно быть между:',
        minLength: 'Минимальная длина: ',
        maxLength: 'Максимальная длина: ',
        invalidInputForCodeType: 'Недопустимый ввод для выбранного типа кода',
        invalidCodeOrNoPermission:
            'Код недействителен или у вас недостаточно полномочий для выполнения этого действия.',
        endDateLowerThanStart:
            'Дата окончания не может быть меньше даты начала',
        iconAlreadyTaken: 'Иконка уже занята',
        notEnoughQuantityInStorage: 'Недостаточное количество в хранилище.',
        valueTooLow: 'Значение слишком низкое',
        valueTooHigh: 'Значение слишком высокое',
        maxAvailableQuantity: 'Максимальное количество',
        someFilesRejectedDueToSize:
            'Некоторые файлы были отклонены из-за размера. Максимальный размер одного файла:',
        cameraDeviceNotFound: 'Yстройство камеры не найдено',
        cameraPermissionDenied:
            'Доступ к камере устройства был заблокирован в настройках сайта, сбросьте настройки сайта и разрешите использование камеры.',
        passwordResetLinkExpired:
            'Срок действия ссылки для сброса пароля истек',
        noInternetConnection: 'Нет соединения с интернетом',
        minimum: 'Минимум',
        mustBeGreaterThan: 'Должно быть больше',
        noEventTypesDefined: 'Не определено ни одного типа события',
        regexPatternDelimiterError:
            'Разделитель должен быть опущен с помощью символа \\ n например: \\/',
        emailNotMatchPatternDefiniedInTenant:
            'Электронная почта не соответствует шаблону, определенному в конфигурации',
        partMustHaveEntriesToCorrectQuantity:
            'Деталь должна иметь записи для корректировки количества.',
        fileTooBigToOpenWillBeDownloaded:
            'Файл слишком большой для открытия, файл будет загружен на ваше устройство.',
        entriesNotSavedDueToCollision:
            'Записи не были добавлены. События уже существуют в выбранное время.',
        someEntriesWereRejected:
            'Некоторые записи не были добавлены, поскольку конфликтуют с другими событиями.',
        toolAlreadyInCart: 'Этот инструмент уже в вашей корзине',
        toolAlreadyTaken: 'Этот инструмент уже выпущен',
        toolIsNotTaken: 'Этот инструмент не был выпущен',
        documentNotEditable: 'Этот документ нельзя редактировать',
        notPermissionsToEditDocument:
            'У вас нет разрешения на редактирование этого документа.',
        cannotLoadDocumentNoPath:
            'Не удалось загрузить документ — неверный адрес.',
        locationNameNotMatchPatternDefiniedInTenant:
            'Имя не соответствует правилу, определенному в настройках',
        noFloorLayoutProvided: 'Этаж не имеет определенной карты',
        maximum: 'Максимальное значение',
        allLanguagesRequired: 'Завершите значение на всех языках',
        noItemsAvailable: 'Нет доступных товаров',
        noFlagsConfigured: 'Флаги не определены',
        noSkillsDefined: 'Навык не определен',
        someoneIsWorkingOnIssue:
            'Не все сотрудники завершили работу над этим отчетом. Вы уверены, что хотите положить этому конец?',
        fillAllRequiredParameters: 'Заполните все необходимые параметры.',
        issueLimitError:
            'Достигнут лимит задач в выбранной категории для группы: ',
        issueLimitError2: 'и функция: ',
        duplicateError: 'Это значение уже существует',
        versionErrorMessage:
            'Ваши недавние изменения не были сохранены, поскольку в это же время изменения внес кто-то другой. Обновите страницу и повторите попытку.',
        firstLoginTrustedDeviceError:
            'При первом входе на новом устройстве необходимо ввести адрес электронной почты и пароль.',
        tagNotFound: 'Карта/бирка не распознана',
        noChecklistsAssignedToControl:
            'Для выбранного элемента управления не назначен контрольный список.',
        lockerNotConnected: 'Замок не подключен',
        lockerNotAvailable: 'Замок недоступен',
        noChecklistItemsError: 'Контрольный список не настроен',
    },
    navDrawer: {
        dashboard: 'Панель управления',
        issues: 'Проблемы',
        timetable: 'Расписание',
        machines: 'Машины',
        tools: 'Инструменты',
        parts: 'Части',
        storage: 'Склад',
        staff: 'Персонал',
        configuration: 'Конфигурация',
        notes: 'Заметки',
        notifications: 'Уведомления',
        profile: 'Профиль',
        supervision: 'Наблюдение',
    },
    barcodeScanner: {
        barCode: 'Штрих-код',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Категория...',
        selectCategory: 'Выберите категорию',
        noSubcategories: 'Нет подкатегорий',
    },
    companies: {
        addCompany: 'Добавить компанию',
        editCompany: 'Редактировать компанию',
        fullName: 'Полное название',
        shortName: 'Краткое название',
        group: 'Группа',
        country: 'Страна',
        city: 'Город',
        street: 'Улица',
        postCode: 'Почтовый код',
        phone: 'Телефон',
        email: 'Электронная почта',
        website: 'Веб-сайт',
        NIP: 'NIP',
        REGON: 'Национальный реестр деловых субъектов',
        active: 'Активный',
        nameRequired: 'Требуется название',
        shortNameRequired: 'Требуется название',
    },
    issues: {
        tookAt: 'Принято в',
        changeHistory: 'История изменений',
        load: 'Загрузить',
        date: 'Дата',
        createdBy: 'Создано',
        action: 'Действие',
        data: 'Данные',
        created: 'Создано',
        updated: 'Обновлено',
        deleted: 'Удалено',
        restored: 'Восстановлено',
        issues: 'Проблемы',
        issue: 'Проблема',
        by: 'от',
        name: 'Имя',
        applicantsDescription: 'Описание заявителя',
        accidentDescription: 'Описание аварии',
        jobDescription: 'Описание работы',
        jobSummary: 'Сводка работы',
        category: 'Категория',
        status: 'Статус',
        noFlow: '[Нет потока]',
        equipment: 'Оборудование',
        criticality: 'Критичность',
        hour: 'Час',
        formalConfirmation: 'Официальное подтверждение',
        formalConfirmationShortcut: 'ОП',
        formalConfirmationRequired: 'Требуется ОП',
        parameter: 'Параметр',
        value: 'Значение',
        addIssue: 'Добавить проблему',
        expectedCompletionDate: 'Ожидаемая дата завершения',
        issueDescription: 'Описание проблемы',
        partsUsage: 'Использование деталей',
        assignedEmployees: 'Назначенные сотрудники',
        requiredHelp: 'Требуемая помощь',
        returnParts: 'Вернуть деталь',
        confirmUnassignEmployeeWhoTakenIssue:
            'Этот сотрудник взял выбранную проблему. Вы хотите удалить его?',
        responsibleUser: 'Ответственный пользователь',
        responsibleRules: 'Ответственные пользователи - правила',
    },
    machines: {
        machines: 'Машины',
        xIssuesNotPlanned: ' (не запланировано)',
        noIssues: 'Нет проблем',
    },
    maintenance: {
        maintenance: 'Техническое обслуживание',
    },
    notes: {
        notes: 'Заметки',
        note: 'Заметка',
        title: 'Название',
        archived: 'Архивировано',
    },
    parts: {
        parts: 'Детали',
        warehouseOutgoings: 'Исходящие из склада',
        fittingEquipmentTypes: 'Подходящие типы оборудования',
        goToEquipmentType: 'Перейти к типу оборудования',
        selectPart: 'Выберите деталь',
        usageReason: 'Причина',
        usageOtherReason: 'Другое',
        replacements: 'Замены',
        partEntry: 'Вход детали',
        goToPart: 'Перейти к детали',
        fittingMachines: 'Соответствие машин',
    },
    costCenter: {
        costCenter: 'Центр расходов',
    },
    equipmentTypes: {
        equipment: 'Оборудование',
        newEquipmentType: 'Новый тип оборудования',
        fittingParts: 'Подходящие детали',
        goToParts: 'Перейти к детали',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Определения машин и инструментов',
    },
    flows: {
        flow: 'Поток',
        states: 'Состояния',
        transitions: 'Переходы',
        state: 'Состояние',
        default: 'По умолчанию',
        warning: 'Предупреждение',
        problem: 'Проблема',
        fixing: 'Исправление',
        finished: 'Законченный',
    },
    parameters: {
        categoryParameter: 'Параметр категории',
        equipmentTypeParameter: 'Параметр типа оборудования',
    },
    staff: {
        staff: 'Сотрудники',
        editUserAccess: 'Изменить доступ пользователя',
        permissionsUpdated: 'Права доступа обновлены',
        passwordUpdated: 'Пароль обновлен',
        codeUpdated: 'Код обновлен',
        changePasswordAndCode: 'Изменить пароль и код',
        goToLicenses: 'Перейти к лицензиям',
        editAccess: 'Изменить доступ',
        editUser: 'Изменить пользователя',
        addUser: 'Добавить нового пользователя',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Статус учетной записи',
        phoneNumber: 'Номер телефона',
        department: 'Отдел',
        passwordChange: 'Изменить пароль',
        codeChange: 'Изменить код',
        newPassword: 'Новый пароль',
        confirmNewPassword: 'Подтвердите новый пароль',
        changePassword: 'Изменить пароль',
        newCode: 'Новый код',
        confirmNewCode: 'Подтвердите новый код',
        changeCode: 'Изменить код',
        addEntry: 'Добавить запись',
        editEntry: 'Изменить запись',
        editLicense: 'Изменить лицензию',
        addLicense: 'Добавить лицензию',
        licenseNumber: 'Номер лицензии',
        prefferedLocale: 'Предпочитаемый язык',
        oldPassword: 'Старый пароль',
        newPasswordConfirmation: 'Подтвердите новый пароль',
        reading: 'Отображение',
        creating: 'Создание',
        updating: 'Обновление',
        deleting: 'Удаление',
        importScheduleFile: 'Импорт расписания из файла',
        importSchedule: {
            errors: {
                user_not_found: 'Пользователь не найден [{user}]',
                user_found_many: '{count} пользователя найдено [{user}]',
                event_collision: 'столкновение событий',
                hour_cell_parse: 'Ошибка синтаксического анализа ячейки',
            },
        },
        oldCode: 'старый код',
        newCodeConfirmation: 'Подтверждение нового кода',
        setAccessBasedOnProfile: 'Предоставить доступ на основе профиля',
        selectAccessMergeType: 'Выберите способ объединения разрешений',
        noAccessesInProfileMessage:
            'Выбранный профиль не имеет разрешений. Вы все равно хотите перезаписать?',
    },
    breadCrumb: {
        configuration: 'Конфигурация',
        locations: 'Местоположения',
        home: 'Главная',
        machines: 'Машины',
        tools: 'Инструменты',
        issues: 'Проблемы',
        notes: 'Заметки',
        maintenance: 'Техобслуживание',
        parts: 'Запчасти',
        warehouse: 'Склад',
        dictionary: 'Словарь',
        categories: 'Категории',
        parameters: 'Параметры',
        costCenter: 'Центр затрат',
        flows: 'Потоки',
        states: 'Состояния',
        transitions: 'Переходы',
        shiftSchemas: 'Схемы смен',
        shifts: 'Смены',
        definitionsOfMachinesAndToolsTypes:
            'Определения типов машин и инструментов',
        add: 'Добавить',
        edit: 'Редактировать',
        staff: 'Персонал',
        licenses: 'Лицензии',
        entries: 'Записи',
        companiesDatabase: 'База компаний',
        companyManagement: 'Управление компанией',
        companyData: 'Данные компании',
        supportedLanguages: 'Поддерживаемые языки',
        en: 'Английский',
        pl: 'Польский',
        es: 'Испанский',
        de: 'Немецкий',
        it: 'Итальянский',
        fr: 'Французский',
        ru: 'Русский',
        uk: 'Украинский',
        pt: 'Португальский',
        defaultLanguage: 'Язык по умолчанию',
        notifications: 'Уведомления',
        notificationsManagement: 'Управление уведомлениями',
        myProfile: 'Мой профиль',
    },
    attributeTypes: {
        text: 'Текст',
        note: 'Заметка',
        integer: 'Целое число',
        decimal: 'Десятичное число',
        date: 'Дата',
        time: 'Время',
        dateTime: 'Дата и время',
        color: 'Цвет',
        icon: 'Иконка',
        boolean: 'Да/Нет',
    },
    costCalculator: {
        costCalculator: 'Калькулятор стоимости',
        waitTime: 'Время ожидания',
        serviceTime: 'Время обслуживания',
        suspendTime: 'Время приостановления',
        totalTime: 'Общее время',
        estimatedCost: 'Расчетная стоимость',
        calculate: 'Рассчитать',
        withoutParts: 'Без запчастей',
        timeOfReportingIssue: 'Время сообщения о неисправности',
        timeOfServiceStart: 'Время начала обслуживания',
        timeOfReportingEnd: 'Время окончания обслуживания',
        days: 'Дни',
        hours: 'Часы',
        minutes: 'Минуты',
        enterNewTime: 'Ввести новое время',
        fromIssueReportToServiceStart:
            'Время с момента заявки до начала обслуживания',
        fromServiceStartToServiceEnd:
            'Время с начала обслуживания до его окончания',
        workTime: 'Рабочее время',
        includeAwaitingTime: 'Включить время ожидания',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Мои задачи',
                assignedToMe: 'Назначенные мне',
                assignedToGroup: 'Назначенные моей группе',
                tookByMe: 'Взятые мной',
                takeIssueBtn: 'Взять',
                arriveIssueBtn: 'Я приехал',
                finishIssueBtn: 'Закончить',
                history: 'История',
                myResponsible: 'я несу ответственность за',
            },
        },
    },
    synchronization: {
        enabled: 'Включено',
        hasHeaders: 'Есть заголовки',
        leaveFile: 'Оставить файл',
        host: 'Хост',
        port: 'Порт',
        protocol: 'Протокол',
        username: 'Имя пользователя',
        password: 'Пароль',
        root: 'Корень',
        encoding: 'Кодировка',
        separator: 'Разделитель',
        externalSystemId: 'ID внешней системы',
        cronExpression: 'Выражение Cron',
        appendFullStock: 'Добавить полный склад',
        includeHeaders: 'Включить заголовки',
        withTrashed: 'С удаленными данными',
        filePattern: 'Шаблон файла',
    },
    processes: {
        created_at: 'Создано',
        started_at: 'Начато',
        updated_at: 'Обновлено',
        finished_at: 'Завершено',
        attempts: 'Попыток',
        queue: 'Очередь',
        job_id: 'ID задачи',
        job_uuid: 'UUID задачи',
        progress_max: 'Макс. прогресс',
        progress_now: 'Текущий прогресс',
        outputMessage: 'Сообщение вывода',
        status: {
            queued: 'в очереди',
            executing: 'выполняется',
            finished: 'завершено',
            failed: 'не удалось',
            retrying: 'повторная попытка',
            undefined: 'неопределенный',
        },
    },
    weekDays: {
        mo: 'Понедельник',
        tu: 'Вторник',
        we: 'Среда',
        th: 'Четверг',
        fr: 'Пятница',
        sa: 'Суббота',
        su: 'Воскресенье',
    },
    reports: {
        reports: 'Отчеты',
        dateFrom: 'Дата начала',
        dateTo: 'Дата окончания',
        types: {
            operation_sheet: 'Операционный лист',
            issue_summary: 'краткое изложение проблемы',
            grouped_summary: 'Сводный отчет',
            storage_operations: 'Складские операции',
            part_quantity_export: 'Количество деталей',
        },
        reportFor: 'Отчет за',
        includeQuantityLeft0: 'Включить детали с нулевым количеством',
    },
    logs: {
        issues: {
            escalation: 'Эскалация ({minutes} мин) - уведомление отправлено',
        },
        issueEmployee: {
            assignedAt: 'Сотрудник назначен:',
            receivedAt: 'Сотрудник получил:',
            tookAt: 'Сотрудник принял',
            finishedAt: 'Сотрудник завершил',
            deletedAt: 'Сотрудник удален из обращения',
        },
    },
    units: {
        no: 'кусок',
        st: 'набор',
    },
    rrule: {
        frequency: 'Частота',
        dtstart: 'Дата начала',
        tzid: 'Часовой пояс',
        until: 'До',
        count: 'Считать',
        interval: 'интервал',
        wkst: 'День начала',
        byweekday: 'К будням',
        bymonth: 'По месяцам',
        yearly: 'Ежегодн',
        monthly: 'Ежемесячно',
        weekly: 'Еженедельно',
        daily: 'Ежедневно',
        hourly: 'Почасовая',
        minutely: 'Минутно',
        secondly: 'Во-вторых',
        infinitePeriodicityMessage:
            'Периодичность бесконечна, из-за производительности отображается только 500 строк',
    },
    months: {
        jan: 'январь',
        feb: 'февраль',
        mar: 'Маршировать',
        apr: 'Апрель',
        may: 'Может',
        jun: 'Июнь',
        jul: 'Июль',
        aug: 'Август',
        sep: 'Сентябрь',
        oct: 'октябрь',
        nov: 'ноябрь',
        dec: 'Декабрь',
    },
    charts: {
        charts: 'графики',
        count: 'Количество выпусков',
        total: 'Общее время выпуска (от отчета до завершения)',
        serw: 'Общее время ремонта (Ttotal - Twait)',
        mttr1: 'Среднее время от отчета до завершени',
        mttr2: 'Среднее время от дубля до финиш',
        mtbf: 'Среднее время безотказной работы между проблемами',
        mttf: 'Среднее время до отказа',
    },
    accessMergeValues: {
        sum: 'Сумма',
        product: 'Продукт',
        overwrite: 'перезаписать',
    },
    tpm: {
        history: 'История',
        standardObstacle: 'Стандартное препятствие',
        customObstacle: 'Пользовательское препятствие',
        bhp: 'Безопасность и охрана труда',
        returnToMainPage: 'Вернуться на главную страницу',
        bhpMessage:
            'Если вы замечаете риски безопасности, немедленно сообщите об этом своему непосредственному руководителю и используйте форму уведомления, находящуюся под доской объявлений.',
        ok: 'OK',
        send: 'Отправить',
        description: 'Описание',
        title: 'Заголовок',
        realization: 'Реализация',
        answer: 'Ответ',
        pendingSurveys: 'Ожидающие опросы',
        surveys: 'Опросы',
        systemSurvey: 'Системный опрос',
        addPage: 'Добавить страницу',
        createSurvey: 'Создать опрос',
        addSection: 'Добавить раздел',
        addQuestion: 'Добавить вопрос',
        questionContent: 'Содержание вопроса',
        answerOption: 'Вариант ответа',
        addQuestionAnswer: 'Добавить вариант ответа',
        surveyName: 'Название опроса',
        sectionName: 'Название раздела',
        noSurveyAnswers: 'Нет ответов',
        removeSection: 'Удалить раздел',
        published: 'Опубликовано',
        unpublished: 'Неопубликовано',
        pendingPublication: 'Ожидают публикации',
        removeQuestion: 'Удалить вопрос',
        removeAnswer: 'Удалить вариант ответа',
        publish: 'Опубликовать',
        unpublish: 'Отменить публикацию',
        previewResults: 'Просмотреть результаты',
        supervisior: 'Руководитель',
        surveyResults: 'Результаты опроса',
        surveysEvents: 'Конфигурация событий - опросы',
        operatedBy: 'Управляется',
        confirmReadInformations: 'Я подтверждаю, что ознакомился с информацией',
        noticeContent: 'Содержание уведомления',
        notice: 'Уведомление',
        surveyEventName: 'Название события',
        survey: 'Опрос',
        newIssue: 'Новая проблема',
        surveyEventConfigurationAlreadyExists:
            'Конфигурация события уже существует',
        lastComment: 'Последний комментарий ответственного лица',
        surveyNotConfigured: 'Опрос не настроен',
        fillSurvey: 'Заполнить опрос',
        singleSurveyEntries: 'единичные результаты',
        groupedSurveyEntries: 'Сгруппированные результаты',
        publicationId: 'Идентификатор публикации',
        publicationDate: 'Дата публикации',
        versionId: 'идентификатор версии',
        answersCount: 'Количество ответов',
        answers: 'Ответы',
        withoutSupervisor: 'Нет супервайзера',
        defaultSupervisor: 'Супервайзер по умолчанию',
        flowStateFlags: 'Флаги состояния',
        qrActionsSettings: 'Настройки действия QR-кода',
        loginRequired: 'Требуется авторизация',
        questionContext: 'контекст вопроса',
        currentSurveyVersionPreview:
            'Предварительный просмотр текущей версии опроса',
        surveyDescription: 'Описание опроса',
        sectionDescription: 'Описание раздела',
        instructions: 'инструкции',
        instruction: 'инструкция',
        instructionRevisions: 'Редакции',
        instructionRevision: 'пересмотр',
        checklists: 'Контрольные списки',
        checklist: 'Контрольный список',
        checklistItem: 'Пункт списка',
        manageChecklistFields: 'Управление элементами списка',
        checklistItemDisplayOptions: 'Отображаемые элементы',
        revisionAutoRejectedInfo:
            '[Система] Отклонено — создана новая редакция',
    },
    checklists: {
        itemBasic: 'Базовый элемент',
        itemSeparator: 'Разделитель',
        itemSection: 'Раздел',
        publish: 'Публиковать',
        previewCurrentVersion: 'Предварительный просмотр текущей версии',
    },
};
